import {Button, Chip, Grid, Typography, OutlinedInput} from "@mui/material"
import {SmartKodiMap, createMarkers} from "../../components/map"
import {useCallback, useEffect, useState} from "react"
import {ResponsiveRow} from "../../constants/layout.constants"
import Back from "@mui/icons-material/ChevronLeft"
import Straighten from "@mui/icons-material/Straighten"
import Bed from "@mui/icons-material/AirlineSeatFlat"
import Bath from "@mui/icons-material/Bathtub"
import {Box} from "@mui/system"
import {
    DetailsCardContainer,
    ModalAcceptButton,
    ModalCancelButton,
    StyledDataGrid
} from "../../constants/component.constants"
import Favorite from "@mui/icons-material/Favorite"
import NotFavorite from "@mui/icons-material/FavoriteBorder"
import ListingApplicationModal from "../../components/modals/listings/listingApplicationModal"
import ListingBookingModal from "../../components/modals/listings/listingBookingModal"
import {useDispatch, useSelector} from "react-redux"
import {formatCurrency, formatDate, formatDateTime, isNullUndefined, hasValidImages, titleCase} from "../../util/util"
import RegisterForm from "./auth/registerForm"
import {
    cancelTourBooking,
    getAllListings,
    getAppointmentForListing, getListingById, getListingByIdSecured, listAppointmentsForListing,
    processListingAppointment,
    saveAppointment,
    saveFavoriteListing,
} from "../../services/listingsServices/listing.service"
import {handleErrorResponse, setMessage} from "../../actions/message"
import IconButton from "@mui/material/IconButton"
import ListingGalleryViewer from "../../components/modules/listings/listingGalleryViewer"
import ListingModalContainerModule from "../../components/modules/listingModalContainer"
import {GET_LISTING_IMAGE_URL} from "../../constants/url.constants";
import { useNavigate, useParams } from "react-router-dom"
import placeholderImage from "../../images/building-placeholder.png"
import { CalendarToday, Check, Clear, Pause } from "@mui/icons-material"
import { GridActionsCellItem } from "@mui/x-data-grid"
import { amber, green, red } from "@mui/material/colors"
import ConfirmationModal from "../../components/modals/confirmation"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"

// Helper function to get user-friendly status display
const getStatusDisplay = (status) => {
    switch (status) {
        case 'Pending':
            return { text: 'Pending', color: '#FFA500' }; // Orange
        case 'Approved':
            return { text: 'Approved', color: '#4CAF50' }; // Green
        case 'Rejected':
            return { text: 'Rejected', color: '#F44336' }; // Red
        default:
            return { text: 'Unknown', color: '#757575' }; // Grey
    }
};

export function SuggestedDatesSelector({ selectedDates, setSelectedDates, isOwnBooking = false }) {
    const [currentDate, setCurrentDate] = useState(null);
    const tomorrow = dayjs().add(1, 'day');

    const handleAddDate = () => {
        if (currentDate && !selectedDates.some(d => dayjs(d).isSame(dayjs(currentDate)))) {
            setSelectedDates([...selectedDates, currentDate]);
            setCurrentDate(null);
        }
    };

    const handleDateChange = (newDate) => {
        setCurrentDate(newDate);
        // For own bookings, automatically add the date when selected
        if (isOwnBooking && newDate) {
            setSelectedDates([newDate]);
        }
    };

    const handleDateAccept = (newDate) => {
        // For listing owners, automatically add the first date when confirmed
        if (!isOwnBooking && newDate && selectedDates.length === 0) {
            setSelectedDates([newDate]);
            setCurrentDate(null); // Clear the date picker
        }
    };

    const handleRemoveDate = (dateToRemove) => {
        setSelectedDates(selectedDates.filter(d => !dayjs(d).isSame(dayjs(dateToRemove))));
    };

    return (
        <Box sx={{ mb: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    label={isOwnBooking ? "Pick a Date" : "Suggest a date"}
                    value={isOwnBooking ? selectedDates[0] || null : currentDate}
                    onChange={handleDateChange}
                    onAccept={handleDateAccept}
                    sx={{ mr: 2 }}
                    defaultValue={tomorrow}
                    disablePast
                />
            </LocalizationProvider>

            {!isOwnBooking && (
                <Button 
                    variant="contained" 
                    onClick={handleAddDate} 
                    disabled={!currentDate}
                    sx={{ display: selectedDates.length === 0 ? 'none' : 'inline-flex' }}
                >
                    Add Another Date
                </Button>
            )}
            <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1">{isOwnBooking ? "Selected Date:" : "Selected Dates:"}</Typography>
                <ResponsiveRow sx={{ flexWrap: "wrap", gap: 1 }}>
                    {selectedDates.map((date, idx) => (
                        <Chip
                            key={idx}
                            label={formatDateTime(new Date(date))}
                            onDelete={() => handleRemoveDate(date)}
                            sx={{ m: 0.5 }}
                        />
                    ))}
                    {selectedDates.length === 0 && (
                        <Typography variant="body2" sx={{ color: "#888" }}>
                            {isOwnBooking ? "No date selected" : "No dates selected"}
                        </Typography>
                    )}
                </ResponsiveRow>
            </Box>
        </Box>
    );
}

export default function ListingView(props) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector((state) => state.auth.user);
    const [selectedImage, setSelectedImage] = useState()
    const [favorite, setFavorite] = useState(false)
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
    const [openBookingModal, setOpenBookingModal] = useState(false)
    const [openApplicationModal, setOpenApplicationModal] = useState(false)
    const [registerModal, setRegisterModal] = useState(false)
    const [galleryModal, setGalleryModal] = useState(false)
    const [hasABooking, setHasABooking] = useState(false)
    const [myAppointment, setMyAppointment] = useState()
    const [appointments, setAppointments] = useState([])
    const [loading, setLoading] = useState(true)
    const [action, setAction] = useState("save")
    const [total, setTotal] = useState(0)
    const [selectionModel, setSelectionModel] = useState([])
    const [rowsPerPage] = useState(12)
    const [listing, setListing] = useState(props.listing || {}) // Provide empty object as fallback
    const [listings,] = useState(props.listings || [])
    const [markers, setMarkers] = useState(null)
    const [center, setCenter] = useState(null)
    const {listingId} = useParams()
    const [confirmType, setConfirmType] = useState("");
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [reason, setReason] = useState("");
    const [selectedDates, setSelectedDates] = useState([])

    useEffect(() => {
        if (isLoggedIn) {
            getListingByIdSecured(listingId)
                .then((response) => {
                    if (isNullUndefined(response)) {
                        if (window.history.length > 1) {
                            navigate(-1)
                        } else {
                            navigate("/listings/favorites")
                        }
                        return
                    }
                    setListing(response)
                    setCenter({lat: parseFloat(response?.latitude), lng: parseFloat(response?.longitude)})
                    // Set favorite state from backend response
                    if (response?.isFavorite !== undefined) {
                        setFavorite(response.isFavorite)
                    }
                }).catch(error => {
                    handleErrorResponse(error)
                    if (window.history.length > 1) {
                        navigate(-1)
                    } else {
                        navigate("/listings/favorites")
                    }
                })
        } else {
            getListingById(listingId)
                .then((response) => {
                    if (isNullUndefined(response)) {
                        if (window.history.length > 1) {
                            navigate(-1)
                        } else {
                            navigate("/listings/favorites")
                        }
                        return
                    }
                    setListing(response)
                    setCenter({lat: parseFloat(response?.latitude), lng: parseFloat(response?.longitude)})
                }).catch(error => {
                    handleErrorResponse(error)
                    if (window.history.length > 1) {
                        navigate(-1)
                    } else {
                        navigate("/listings/favorites")
                    }
                })
        }
    }, [isLoggedIn, listingId, navigate])

    useEffect(() => {
        getAllListings()
            .then((response) => {
                createMarkers(setMarkers, response, listing)
            })
    }, [listing])
    

    function getChipProps(row) {
        const status = row.status
        if (!isNullUndefined(status)) {
            if (status === "Approved") {
                return {
                    icon: <Check style={{fill: green[500]}}/>,
                    label: status,
                    style: {
                        borderColor: green[500],
                    },
                }
            } else if (status === "Pending") {
                return {
                    icon: <Pause style={{fill: amber[500]}}/>,
                    label: status,
                    style: {
                        borderColor: amber[500],
                    },
                }
            } else if (status === "Rejected") {
                return {
                    icon: <Clear style={{fill: red[500]}}/>,
                    label: status,
                    style: {
                        borderColor: amber[500],
                    },
                }
            }
        }
    }

    function handleAppointmentActions(row, actionType) {
        setConfirmType(actionType)
        setSelectedBooking(row)
    }

    async function handleApproveOrRejectAppointment() {
        setLoading(true);
        switch (confirmType) {
            case "approve":
                await processListingAppointment({
                    appointmentId: selectedBooking?.id,
                    action: "approve",
                    reason: reason
                })
                setReason("")
                break;
            case "reject":
                await processListingAppointment({
                    appointmentId: selectedBooking?.id,
                    action: "reject",
                    reason: reason
                })
                setReason("")
                break;
            case "reschedule":
                const data = {
                    rescheduleReason: reason,
                    suggestedTimes: selectedDates,
                    appointmentDate: selectedDates.length > 0 ? selectedDates[0] : null,
                    appointmentId: selectedBooking?.id,
                    listingId: listing?.id
                }
                await saveAppointment(data)
                setSelectedDates([])
                setReason("")
                break;
            default:
                break
        }

        setConfirmType("")
        setSelectedBooking(null)
        listAppointmentsForListing(listing?.id)
            .then((response) => {
                parseAppointmentsData(response)
            })
            .catch((error) => {
                console.error('Error fetching appointments:', error)
                setAppointments([])
                setTotal(0)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const columns = [
        {headerName: 'Appointment Date', field: 'appointmentDate', flex: 1,
            valueFormatter: (row) => {
                const date = new Date(row.value)
                return formatDateTime(date)
            },
        },
        {headerName: 'Visitor', field: 'visitorName', flex: 1},
        {headerName: 'Email', field: 'visitorEmail', flex: 1},
        {headerName: 'Contact', field: 'visitorContact', flex: 1},
        {
            headerName: 'Status', field: 'status', flex: 1,
            renderCell: (params) => {
                return (
                    <Chip variant="outlined" size="small" {...getChipProps(params?.row)} />
                )
            },
        },
        {
            headerName: 'Actions', field: 'actions', flex: 1, type: 'actions',
            getActions: (params) => {
                let arr = []
                if(params?.row?.status === "Pending") {
                    arr.push(
                        <GridActionsCellItem
                            icon={<Check/>}
                            onClick={() => handleAppointmentActions(params.row, "approve")}
                            label="Approve"
                            showInMenu
                        />
                    )
                    arr.push(
                        <GridActionsCellItem
                        icon={<CalendarToday/>}
                        onClick={() => handleAppointmentActions(params.row, "reschedule")}
                        label="Reschedule"
                        showInMenu
                        />
                    )
                }
                arr.push(
                    <GridActionsCellItem
                        icon={<Clear color="red" />}
                        onClick={() => handleAppointmentActions(params.row, "reject")}
                        label="Reject"
                        showInMenu
                    />
                )

                return arr
            },
        },
    ]

    useEffect(() => {
        if (listing?.latitude && listing?.longitude) {  // Only set if we have coordinates
            setCenter({lat: parseFloat(listing.latitude), lng: parseFloat(listing.longitude)})
            createMarkers(setMarkers, listings, listing)
        }
    }, [listing, listings])

    const fetchOwnTourBookingForListing = useCallback(() => {
        // Early return if no listing or no id
        if (!listing?.id) {
            setHasABooking(false)
            setMyAppointment({})
            setAction("save")
            return
        }

        getAppointmentForListing(listing?.id)
            .then((response) => {
                const target = response?.appointment
                const appointment = {}
                if(!isNullUndefined(target)) {
                    appointment.id = target.id
                    appointment.date = target.appointmentDate
                    appointment.facility = target.listing?.propertyName
                    appointment.created = target.dateCreated
                    appointment.status = target.status
                    appointment.reason = target.reason
                    setHasABooking(true)
                } else {
                    setHasABooking(false)
                }
                setMyAppointment(appointment)
            })
            .catch((error) => {
                setHasABooking(false)
                setMyAppointment({})
            })
        setAction("save")
    }, [listing])

    useEffect(() => {
        if (!listing?.id) {
            setLoading(false)
            return
        }

        if (listing?.favorite === true) {
            setFavorite(listing?.favorite)
        }

        if(isNullUndefined(user)) {
            setLoading(false)
            return
        } else if(listing?.addedBy === user?.userId) {
            // fetch all tour bookings for this listing
            listAppointmentsForListing(listing?.id)
                .then((response) => {
                    parseAppointmentsData(response)
                })
                .catch((error) => {
                    console.error('Error fetching appointments:', error)
                    setAppointments([])
                    setTotal(0)
                })
                .finally(() => {
                    setLoading(false)
                })
        } else {
            // fetch my tour booking for this listing
            fetchOwnTourBookingForListing()
            setLoading(false)
        }
    }, [fetchOwnTourBookingForListing, listing, user])

    function parseAppointmentsData(data) {
        const newAppointmentsData = []
        data?.forEach(target => {
            const appointment = {
                id: target.id,
                appointmentDate: target.appointmentDate,
                visitorName: target?.person?.name,
                visitorEmail: target?.person?.email,
                visitorContact: target?.person?.phone,
                status: target.status
            }
            newAppointmentsData.push(appointment)
        })
        setAppointments(newAppointmentsData)
        setTotal(data?.length)
    }

    function handleApplicationClose() {
        setOpenApplicationModal(false)
    }

    function handleBookingClose() {
        setOpenBookingModal(false)
    }

    function handleApplyClicked() {
        isLoggedIn ? setOpenApplicationModal(true) : setRegisterModal(true)
    }

    function handleBookTourClicked() {
        isLoggedIn ? setOpenBookingModal(true) : setRegisterModal(true)
    }

    const handleFavClicked = () => {
        if (!isLoggedIn){
            setRegisterModal(true)
            return
        }

        let sendData = {
            listingId: listing?.id
        }

        /**
         * Params to pass to backend:
         * -listingId
         * -isFavorite(true/false)
         * by: rcheruiyot
         */
        saveFavoriteListing(sendData)
            .then((response) => {
                dispatch(
                    setMessage({
                        type: response.type,
                        message: response.message,
                    })
                )
                // Use the isFavorited flag from backend response if available
                const isFav = response.isFavorited !== undefined ? response.isFavorited : !favorite
                setFavorite(isFav)
            })
    }

    function editAppointmentClicked() {
        setAction("edit")
        setOpenBookingModal(true)
    }

    function cancelMyAppointment() {
        cancelTourBooking(myAppointment?.id)
            .then(response => {
                // Clear the booking state immediately after successful cancellation
                setHasABooking(false)
                setMyAppointment({})
                setAction("save")
                setConfirmType("")
                
                dispatch(
                    setMessage({
                        type: response?.type,
                        message: response?.message
                    })
                )
            })
            .catch((error) => {
                // Handle cancellation error
                dispatch(
                    setMessage({
                        type: "error",
                        message: "Failed to cancel booking. Please try again."
                    })
                )
            })
    }

    return (
        <Grid
            sx={{
                backgroundColor: "#efefef",
                paddingTop: {xs: 1.5, sm: 2},
            }}
            container
        >
            {registerModal && (
                <ListingModalContainerModule
                    size="specialListingCreateAccount"
                    cancel={() => setRegisterModal(false)}
                    openModal={registerModal}
                    modalTitle="Create an account to start the application"
                    modalSubTitle="Sign-up form"
                    hideCancel={true}
                >
                    <RegisterForm width="100%"/>
                </ListingModalContainerModule>
            )}
            {listing && (
                <>
                    <Button
                        sx={{
                            width: "auto",
                            alignItems: "center",
                            flexDirection: "row",
                            "&:hover": {
                                cursor: "pointer",
                                backgroundColor: "#fff",
                            },
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <Back
                            sx={{fontSize: "2rem"}}
                        />
                        <Typography variant="h4"> Back</Typography>
                    </Button>
                    <ResponsiveRow
                        sx={{
                            flexWrap: {xs: "wrap", lg: "nowrap"},
                            // flexDirection: { xs: "reverse-row", lg: "row" },
                        }}
                    >
                        <ResponsiveRow
                            sx={{
                                flexDirection: "column",
                                flexWrap: "nowrap",
                                width: {xs: "100%", lg: "50%"},
                                height: "100%",
                            }}
                        >
                            <Box
                                component="img"
                                sx={{
                                    height: "80%",
                                    maxHeight: {xs: "40vh", lg: "60vh"},
                                    width: "100%",
                                    objectFit: "cover",
                                    margin: "auto",
                                    borderRadius: "20px",
                                    cursor: hasValidImages(listing) ? "pointer" : "default",
                                    // Optional: Add slight opacity to indicate no real image
                                    opacity: hasValidImages(listing) ? 1 : 0.8,
                                }}
                                src={
                                    selectedImage || (
                                        hasValidImages(listing)
                                            ? GET_LISTING_IMAGE_URL + "?filename=" + listing.imageFiles[0].systemFileName
                                            : placeholderImage
                                    )
                                }
                                alt={hasValidImages(listing) ? "Property image" : "No images available"}
                                onClick={() => {
                                    if (hasValidImages(listing)) {
                                        setGalleryModal(true)
                                    }
                                }}
                            />

                            <ResponsiveRow
                                sx={{
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    overflowX: "auto",
                                    width: "90%",
                                    margin: "auto",
                                }}
                            >
                                {hasValidImages(listing) ? (
                                    listing.imageFiles.map((image, i) => {
                                        let img = GET_LISTING_IMAGE_URL + "?filename=" + image.systemFileName
                                        return (
                                            <Box
                                                component="img"
                                                sx={{
                                                    height: "150px",
                                                    width: "150px",
                                                    objectFit: "cover",
                                                    padding: "10px",
                                                    borderRadius: "20px",
                                                }}
                                                src={img}
                                                alt={`Property image ${i + 1}`}
                                                onClick={() => setSelectedImage(img)}
                                                key={i}
                                            />
                                        )
                                    })
                                ) : (
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            fontStyle: "italic",
                                            padding: "20px",
                                            textAlign: "center",
                                            width: "100%"
                                        }}
                                    >
                                        No additional images available for this property
                                    </Typography>
                                )}
                            </ResponsiveRow>
                        </ResponsiveRow>
                        <ResponsiveRow
                            sx={{
                                flexDirection: "column",
                                flexWrap: "nowrap",
                                width: {xs: "100%", lg: "50%"},
                                height: "100%",
                                textAlign: "start",
                            }}
                        >
                            <ResponsiveRow>
                                <Typography
                                    sx={{fontSize: "1.7rem", fontWeight: 900, paddingBottom: 0}}
                                >
                                    {listing?.propertyName}
                                </Typography>
                            </ResponsiveRow>
                            <ResponsiveRow
                                sx={{
                                    width: "90%",
                                    justifyContent: {xs: "flex-start", lg: "space-between"},
                                    flexDirection: {xs: "column", lg: "row"},
                                }}
                            >
                                {listing?.plusCode ? (
                                    <a
                                        target={"_blank"}
                                        rel="noreferrer"
                                        title={"View on Map"}
                                        href={
                                            "https://www.google.com.sa/maps/search/" +
                                            encodeURIComponent(listing?.plusCode) +
                                            "?hl=en"
                                        }
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {listing?.plusCode}
                                        </div>
                                    </a>
                                ) : (
                                    "No Location Info"
                                )}

                                <Typography
                                    sx={{
                                        fontSize: "1rem",
                                        fontWeight: 600,
                                        color: "#037171",
                                    }}
                                >
                                    Ksh {formatCurrency(listing?.price)}
                                </Typography>
                            </ResponsiveRow>

                            <ResponsiveRow sx={{alignItems: "center"}}>
                                {favorite ? (
                                    <IconButton
                                        aria-label="Favorite"
                                        onClick={() => {
                                            handleFavClicked()
                                        }}
                                    >
                                        <Favorite
                                            sx={{
                                                margin: "auto 5px",
                                                color: "red",
                                                zIndex: 3,
                                                fontSize: "2rem",
                                                transition: "500ms ease-in-out",
                                            }}
                                        />
                                    </IconButton>
                                ) : (
                                    <IconButton
                                        aria-label="Favorite"
                                        onClick={() => {
                                            handleFavClicked()
                                        }}
                                    >
                                        <NotFavorite
                                            sx={{
                                                margin: "auto 5px",
                                                color: "#aeaeae",
                                                zIndex: 3,
                                                fontSize: "2rem",
                                                transition: "500ms ease-in-out",
                                            }}
                                        />
                                    </IconButton>
                                )}
                                {listing?.sqft && (
                                    <ResponsiveRow
                                        sx={{
                                            width: "auto",
                                            alignItems: "center",
                                            flexDirection: "row",
                                        }}
                                    >
                                        <Straighten sx={{margin: "auto 1px"}}/>{" "}
                                        <Typography
                                            sx={{
                                                fontSize: "1rem",
                                                fontWeight: 700,
                                                margin: "auto 10px",
                                            }}
                                        >
                                            {formatCurrency(listing?.sqft)} SqM
                                        </Typography>
                                    </ResponsiveRow>
                                )}
                                <ResponsiveRow
                                    sx={{
                                        width: "auto",
                                        alignItems: "center",
                                        flexDirection: "row",
                                    }}
                                >
                                    <Bed/>
                                    <Typography
                                        sx={{
                                            fontSize: "1rem",
                                            fontWeight: 700,
                                            margin: "auto 10px",
                                        }}
                                    >
                                        {listing?.beds}
                                    </Typography>{" "}
                                </ResponsiveRow>
                                <ResponsiveRow
                                    sx={{
                                        width: "auto",
                                        alignItems: "center",
                                        flexDirection: "row",
                                    }}
                                >
                                    <Bath sx={{margin: "auto 1px"}}/>
                                    <Typography
                                        sx={{
                                            fontSize: "1rem",
                                            fontWeight: 700,
                                            margin: "auto 10px",
                                        }}
                                    >
                                        {listing?.baths}
                                    </Typography>
                                </ResponsiveRow>
                            </ResponsiveRow>
                            <ResponsiveRow sx={{width: "90%"}}>
                                <Typography
                                    sx={{
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                    }}
                                >
                                    {listing?.description}
                                </Typography>
                            </ResponsiveRow>
                            <ResponsiveRow sx={{justifyContent: "flex-end"}}>
                                <ModalAcceptButton
                                    onClick={handleApplyClicked}
                                    sx={{
                                        backgroundColor: "#009F93",
                                        width: {xs: "100%", lg: "200px"},
                                    }}
                                >
                                    Start Application
                                </ModalAcceptButton>
                                <ListingApplicationModal
                                    openModal={openApplicationModal}
                                    closeModal={handleApplicationClose}
                                    listing={listing}
                                />
                                {
                                    !isNullUndefined(user) && listing?.addedBy !== user?.userId && !hasABooking &&
                                    <ModalAcceptButton
                                        onClick={handleBookTourClicked}
                                        sx={{width: {xs: "100%", lg: "200px"}}}
                                    >
                                        Book Tour
                                    </ModalAcceptButton>
                                }
                                {
                                    isNullUndefined(user) &&
                                    <ModalAcceptButton
                                        onClick={handleBookTourClicked}
                                        sx={{width: {xs: "100%", lg: "200px"}}}
                                    >
                                        Book Tour
                                    </ModalAcceptButton>
                                }
                                {
                                    openBookingModal && (
                                        <ListingBookingModal
                                            closeModal={handleBookingClose}
                                            listing={listing}
                                            action={action}
                                            booking={myAppointment}  // Add this line to pass the booking data
                                            refetchTourBooking={() => fetchOwnTourBookingForListing()}
                                        />
                                    )
                                }
                            </ResponsiveRow>
                            { !isNullUndefined(user) && listing?.addedBy !== user?.userId && hasABooking && myAppointment && (
                                <ResponsiveRow>
                                    <DetailsCardContainer sx={{width: "100%"}}>
                                        <Typography variant="h5">You booked a tour for this listing</Typography>
                                        <Box>Date of Tour: <Typography sx={{ fontWeight: 'bold' }}>{formatDateTime(new Date(myAppointment?.date))}</Typography></Box>
                                        <Box>Listing: <Typography variant="h6">{myAppointment?.facility}</Typography></Box>
                                        <Box>Booking made on: <Typography variant="h6">{formatDate(new Date(myAppointment?.created))}</Typography></Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                            Status: 
                                            <Typography 
                                                variant="body2" 
                                                sx={{ 
                                                    fontWeight: 'bold',
                                                    color: getStatusDisplay(myAppointment?.status)?.color,
                                                    backgroundColor: getStatusDisplay(myAppointment?.status)?.color + '20',
                                                    padding: '4px 12px',
                                                    borderRadius: '12px',
                                                    border: `1px solid ${getStatusDisplay(myAppointment?.status)?.color}`
                                                }}
                                            >
                                                {getStatusDisplay(myAppointment?.status)?.text}
                                            </Typography>
                                        </Box>
                                        {/* Show reason for rescheduled appointments */}
                                        {myAppointment?.status === 'Pending' && myAppointment?.reason && (
                                            <Box sx={{ mt: 1, p: 2, backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                    Reschedule Reason:
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: '#666' }}>
                                                    {myAppointment.reason}
                                                </Typography>
                                            </Box>
                                        )}
                                        <ResponsiveRow
                                            sx={{
                                                width: "100%",
                                                justifyContent: {xs: "center", lg: "flex-end"},
                                                height: {xs: "100px", lg: "70px"}
                                            }}
                                        >
                                            {/* Only show Edit button for active appointments */}
                                            {(myAppointment?.status === 'Pending') && (
                                                <ModalAcceptButton
                                                    onClick={() => editAppointmentClicked()}
                                                    sx={{width: {xs: "100%", lg: "200px"}}}
                                                >
                                                    Reschedule
                                                </ModalAcceptButton>
                                            )}
                                            {/* Only show Cancel button for active appointments */}
                                            {(myAppointment?.status === 'Pending' || myAppointment?.status === 'Approved') && (
                                                <ModalCancelButton
                                                    onClick={() => setConfirmType("cancel")}
                                                    sx={{width: {xs: "100%", lg: "200px"}}}
                                                >
                                                    Cancel
                                                </ModalCancelButton>
                                            )}
                                            {/* Show message for cancelled/rejected appointments */}
                                            {(myAppointment?.status === 'Rejected') && (
                                                <Typography 
                                                    variant="body2" 
                                                    sx={{ 
                                                        color: '#666',
                                                        fontStyle: 'italic',
                                                        textAlign: 'center',
                                                        width: '100%'
                                                    }}
                                                >
                                                    This booking cannot be modified
                                                </Typography>
                                            )}
                                        </ResponsiveRow>
                                    </DetailsCardContainer>

                                </ResponsiveRow>
                            )}
                            <ResponsiveRow
                                sx={{width: "100%", height: "auto", flexDirection: "column"}}
                            >
                                <Typography variant="h5">Properties near by:</Typography>
                                <SmartKodiMap
                                    view={""}
                                    containerStyle={{width: "100%", height: "45vh"}}
                                    center={center}
                                    children={markers}
                                />
                            </ResponsiveRow>
                        </ResponsiveRow>
                    </ResponsiveRow>
                </>
            )}
            <ListingGalleryViewer
                open={galleryModal}
                closeModal={() => {
                    setGalleryModal(false)
                }}
                listingName={listing?.propertyName}
                listingImages={listing?.imageFiles || []}
                listingDescription={listing?.description}
                listingPrice={listing?.price}
            />
            {!isNullUndefined(user) && listing?.addedBy === user?.userId &&
                <ResponsiveRow sx={{width: {xs: "100%", lg: "80%"}, margin: "auto"}}>
                    <Box sx={{width: "90vw", maxWidth:"1400px", margin: "auto"}}>
                        <Typography variant="h5" sx={{marginBlock: "20px"}}>Tour Bookings</Typography>
                        <StyledDataGrid
                            rows={appointments}
                            columns={columns}
                            disableSelectionOnClick
                            loading={loading}
                            autoHeight
                            pageSize={rowsPerPage}
                            rowCount={total}
                            rowsPerPageOptions={[rowsPerPage]}
                            pagination
                            paginationMode="server"
                            onSelectionModelChange={setSelectionModel}
                            selectionModel={selectionModel}
                        />

                    </Box>
                </ResponsiveRow>
            }

            {
                confirmType && (
                    <ConfirmationModal
                        showConfirmationModal={(confirmType)}
                        positiveAction={confirmType === "cancel" ? cancelMyAppointment :handleApproveOrRejectAppointment}
                        negativeAction={() => {
                            setConfirmType("")
                            setReason("")
                            setSelectedDates([])
                        }}
                        severity={(confirmType === "cancel" || confirmType === "reject") ? "error" : confirmType === "approve" ? "success" : "info"}
                        title={`${titleCase(confirmType)} Booking`}
                        body={
                            "Are you sure you want to" + confirmType + " this booking?"
                        }
                        additionalContent={
                            <Box sx={{ width: "100%", mt: 2 }}>
                                {(confirmType === "approve" || confirmType === "reject" || confirmType === "reschedule") && (
                                    <>
                                        <Typography sx={{ mb: 1 }}>Reason {confirmType === "reschedule" && !selectedBooking?.isOwner && <span style={{color: "red"}}>*</span>}</Typography>
                                        <OutlinedInput 
                                            autoFocus={true} 
                                            multiline={true} 
                                            rows={2} 
                                            value={reason} 
                                            onChange={(e) => setReason(e.target.value)} 
                                            placeholder={confirmType === "reschedule" && !selectedBooking?.isOwner ? "Reschedule reason is required..." : `Add a reason why to ${confirmType} this booking...`} 
                                            sx={{marginBottom: "10px", width: "100%"}}
                                            required={confirmType === "reschedule" && !selectedBooking?.isOwner}
                                        />
                                    </>
                                )}

                                {(confirmType === "reschedule") && (
                                    <SuggestedDatesSelector selectedDates={selectedDates} setSelectedDates={setSelectedDates} isOwnBooking={selectedBooking?.isOwner} />
                                )}
                            </Box>
                        }
                        positiveText={confirmType === "cancel" ? "Yes" : `${titleCase(confirmType)}`}
                        negativeText={confirmType === "cancel" ? "No" : "Cancel"}
                    />
                )
            }
        </Grid>
    )
}
